import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOfflineSync } from '../../hooks/useOfflineSync';

export const OfflineIndicator: React.FC = () => {
  const { t } = useTranslation();
  const { isOnline, isSyncing, pendingCount } = useOfflineSync();

  if (isOnline && !isSyncing) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 px-4 py-3 text-center text-sm font-medium transition-all ${
      isSyncing
        ? 'bg-blue-500 text-white'
        : 'bg-amber-500 text-white'
    }`}>
      {isSyncing ? (
        <div className="flex items-center justify-center gap-2">
          <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          {t('pwa.syncing')}
        </div>
      ) : (
        <div>
          <p>{t('pwa.offline')}</p>
          {pendingCount > 0 && (
            <p className="text-xs opacity-80 mt-0.5">
              {pendingCount} {t('common.items')} {t('pwa.offlineMessage').toLowerCase()}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
